module.exports = __webpack_public_path__ + "static/media/source.b15d65e7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/source.gif
// module id = 127
// module chunks = 0